import React from "react";
import PropTypes from "prop-types";

import Link from "../common/Link";
import style from "./ListCard.module.css";
import TopicIcon from "../common/TopicIcon";

const ListCard = ({ list }) => (
  <Link key={list.path} className={style.root} to={list.path}>
    <div className={style.titleRow}>
      <div className={style.icon}>
        <TopicIcon topicKey={list.key} />
      </div>
      <div className={style.title}>{list.name}</div>
    </div>
    <div className={style.row}>
      <div className={style.description}>{list.description}</div>
      {list.count && (
        <div className={style.count}>
          {list.count} {`${list.type.toLowerCase()}s`}
        </div>
      )}
    </div>
  </Link>
);
ListCard.propTypes = {
  list: PropTypes.shape({
    path: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    count: PropTypes.number,
    type: PropTypes.string
  }).isRequired
};
export default ListCard;



// WEBPACK FOOTER //
// ./src/components/list/ListCard.js